module.exports = __webpack_public_path__ + "img/int-avatar.87eab341.svg";